import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Transition as _Transition, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: "/4444logo.png",
  alt: "4444"
}, null, -1)
const _hoisted_3 = { class: "header-nav" }
const _hoisted_4 = { class: "header-nav-list" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<li><a href=\"https://4444.ua/pro-nas/\" class=\"header-nav-link\">Про нас</a></li><li><a href=\"https://4444.ua/ihry/\" class=\"header-nav-link\">Ігри</a></li><li><a href=\"https://4444.ua/nashi-zaly/\" class=\"header-nav-link\">Наші Зали</a></li><li><a href=\"https://4444.ua/hravtsiam/\" class=\"header-nav-link\">Гравцям</a></li><li><a href=\"https://4444.ua/dlia-biznesu/\" class=\"header-nav-link\">Для Бізнесу</a></li><li><a href=\"https://4444.ua/contacts/\" class=\"header-nav-link\">Контакти</a></li>", 6)
const _hoisted_11 = { class: "header-actions" }
const _hoisted_12 = {
  key: 0,
  class: "balance",
  "data-testid": "balance"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("img", {
  src: "/icon-person.png",
  alt: ""
}, null, -1)
const _hoisted_14 = {
  "data-testid": "user-number",
  class: "name"
}
const _hoisted_15 = {
  key: 0,
  class: "logged-menu"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "Персональні дані", -1)
const _hoisted_17 = { class: "name" }
const _hoisted_18 = { class: "name" }
const _hoisted_19 = { class: "name" }
const _hoisted_20 = { class: "name" }
const _hoisted_21 = { class: "logged-menu-item" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "line" }, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "line" }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "line" }, null, -1)
const _hoisted_25 = [
  _hoisted_22,
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = {
  key: 0,
  class: "mob-menu"
}
const _hoisted_27 = { class: "mob-menu-container" }
const _hoisted_28 = { class: "user" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("img", {
  src: "/icon-person.png",
  alt: ""
}, null, -1)
const _hoisted_30 = {
  "data-testid": "mobile-user-number",
  class: "name"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://4444.ua/pro-nas/",
    class: "header-nav-link"
  }, "Про нас")
], -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://4444.ua/ihry/",
    class: "header-nav-link"
  }, "Ігри")
], -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://4444.ua/nashi-zaly/",
    class: "header-nav-link"
  }, "Наші Зали")
], -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://4444.ua/hravtsiam/",
    class: "header-nav-link"
  }, "Гравцям")
], -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://4444.ua/dlia-biznesu/",
    class: "header-nav-link"
  }, "Для Бізнесу")
], -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://4444.ua/contacts/",
    class: "header-nav-link"
  }, "Контакти")
], -1)
const _hoisted_37 = { class: "logged-menu" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "Персональні дані", -1)
const _hoisted_39 = { class: "name" }
const _hoisted_40 = { class: "name" }
const _hoisted_41 = { class: "name" }
const _hoisted_42 = { class: "name" }
const _hoisted_43 = { class: "logged-menu-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: {name: _ctx.ROUTES.HALLS.name},
      class: "header-logo"
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["to"]),
    _createElementVNode("nav", _hoisted_3, [
      _createElementVNode("ul", _hoisted_4, [
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, {
            to: {name: _ctx.ROUTES.HALLS.name},
            class: "header-nav-link active"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Грати")
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _hoisted_5
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("button", {
        class: "btn",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({name: _ctx.ROUTES.DEPOSIT_VIEW.name})))
      }, _toDisplayString(_ctx.$t("header.deposit")), 1),
      (_ctx.balance)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.balance), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["logged", {active: _ctx.showMenu}])
      }, [
        (_ctx.showMenu)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "menu-overlay",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showMenu = false))
            }))
          : _createCommentVNode("", true),
        _createElementVNode("a", {
          href: "#",
          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.showMenu = !_ctx.showMenu), ["prevent"])),
          class: "btn-logged",
          "data-testid": "menu-link"
        }, [
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.userNumber), 1)
        ]),
        _createVNode(_Transition, {
          name: "fade",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            (_ctx.showMenu)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createVNode(_component_router_link, {
                    to: {name: _ctx.ROUTES.PROFILE.name},
                    class: "logged-menu-item"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_16
                    ]),
                    _: 1
                  }, 8, ["to"]),
                  _createVNode(_component_router_link, {
                    to: {name: _ctx.ROUTES.DEPOSIT_VIEW.name},
                    class: "logged-menu-item"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t("header.refill")), 1)
                    ]),
                    _: 1
                  }, 8, ["to"]),
                  _createVNode(_component_router_link, {
                    to: {name: _ctx.ROUTES.WITHDRAWAL_VIEW.name},
                    class: "logged-menu-item",
                    "data-testid": "withdrawal-menu-item"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t("header.withdrawal")), 1)
                    ]),
                    _: 1
                  }, 8, ["to"]),
                  _createVNode(_component_router_link, {
                    to: {name: _ctx.ROUTES.WITHDRAWAL_ORDERS.name},
                    class: "logged-menu-item"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t("header.finances")), 1)
                    ]),
                    _: 1
                  }, 8, ["to"]),
                  _createVNode(_component_router_link, {
                    to: {name: _ctx.ROUTES.HALLS.name},
                    class: "logged-menu-item"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t("header.halls")), 1)
                    ]),
                    _: 1
                  }, 8, ["to"]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", {
                      class: "name",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
                    }, "Закрити сесію")
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ], 2)
    ]),
    _createElementVNode("div", {
      class: "hamburger",
      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.mobMenuShow = !_ctx.mobMenuShow))
    }, _hoisted_25),
    _createVNode(_Transition, {
      name: "slide-fade",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (_ctx.mobMenuShow)
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
              _createElementVNode("div", {
                class: "overlay",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.mobMenuShow = false))
              }),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _hoisted_29,
                  _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.userNumber), 1)
                ]),
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, {
                      to: {name: _ctx.ROUTES.GAME_VIEW.name, params: {url:''}},
                      class: "header-nav-link active"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Головна")
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ]),
                  _hoisted_31,
                  _hoisted_32,
                  _hoisted_33,
                  _hoisted_34,
                  _hoisted_35,
                  _hoisted_36
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _createVNode(_component_router_link, {
                    to: {name: _ctx.ROUTES.PROFILE.name},
                    class: "logged-menu-item"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_38
                    ]),
                    _: 1
                  }, 8, ["to"]),
                  _createVNode(_component_router_link, {
                    to: {name: _ctx.ROUTES.DEPOSIT_VIEW.name},
                    class: "logged-menu-item"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.$t("header.refill")), 1)
                    ]),
                    _: 1
                  }, 8, ["to"]),
                  _createVNode(_component_router_link, {
                    to: {name: _ctx.ROUTES.WITHDRAWAL_VIEW.name},
                    class: "logged-menu-item"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.$t("header.withdrawal")), 1)
                    ]),
                    _: 1
                  }, 8, ["to"]),
                  _createVNode(_component_router_link, {
                    to: {name: _ctx.ROUTES.WITHDRAWAL_ORDERS.name},
                    class: "logged-menu-item"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.$t("header.finances")), 1)
                    ]),
                    _: 1
                  }, 8, ["to"]),
                  _createVNode(_component_router_link, {
                    to: {name: _ctx.ROUTES.HALLS.name},
                    class: "logged-menu-item"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.$t("header.halls")), 1)
                    ]),
                    _: 1
                  }, 8, ["to"]),
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("div", {
                      class: "name",
                      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
                    }, "Закрити сесію")
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}